import { type Context, type ReorderEventKey } from './types';

// ─────────────────────────────────────────────────────────────────────────────

export const validReorderEventKeys: readonly ReorderEventKey[] = [
  'response',
  'orderId',
  'lineItemId',
  'orderType',
  'deliveryAddressName',
  'deliveryOrderDetail',
  'restaurantId',
  'restaurantSlug',
  'restaurantName',
  'reordering',
  'reorderResult',
  'orderTotal',
  'conflictType',
  'userInitiated',
];

export const initialContext: Context = {
  reordering: false,
  response: undefined,
  orderId: '',
  lineItemId: '',
  orderType: 'pickup',
  deliveryAddressName: '',
  deliveryOrderDetail: undefined,
  restaurantId: '',
  restaurantSlug: '',
  restaurantName: '',
  previousStep: undefined,
  groupOrderReorderRequest: undefined,
};
